import { localesUrl } from "config/paths";

export default () => {
  const fetchOptions = {
    method: "GET",
    mode: "cors",
  };

  return fetch(localesUrl, fetchOptions).then(res => {
    if (res.ok) {
      return res.json();
    }
    throw new Error();
  });
};
